
import { Carte } from './carte.js';
import { PasswordValidation } from './password_validation.js';

$(function () {

    var datatable_membre = null;
    var familyDeleteTarget = null;
    var familyDeleteInProgress = false;
    var restoreFamilyFormAfterDeleteDialog = false;

    function init() {
        init_table_membre_famille();
        init_btn();
        init_carte();
        init_password_validation();
    }

    function init_password_validation() {
        // Main form password validation
        var passwordValidator = new PasswordValidation('password', 'password_confirmation', 'member-form');
        $(document).on("submit", "#member-form", function (e) {   
            e.preventDefault();         
            // Validate password before submitting
            if (!passwordValidator.validatePasswordMatch()) {
                // If validation fails, prevent form submission
                return false;
            }
            // If validation passes, submit the form
            this.submit();
        });
    }

    function init_carte() {
        // Chargement de la carte lors de l'onglet carnet
        $(document).on('shown.bs.tab', 'a[data-bs-toggle="pill"]', function (e) {
            if (e.target.hash == "#tab_carnet") {
                var membre_id = $("input[name='id']").val();
                var carte = new Carte();
                var map = carte.chargementCarte();
                carte.chargementGeometries(map, null, null, membre_id,false,null);
            }
        });
    }

    function init_btn() {
        // Édition membre de la famille
        $(document).on("click", ".btn-edition-membre-famille", function (e) {
            var membre_id = $(this).attr("data-id");
            ouvrir_modal_membre(route('edit_membre_famille', membre_id));
        });

        // Nouveau membre de la famille
        $(document).on("click", ".btn-nouveau-membre-famille", function (e) {
            ouvrir_modal_membre(route('create_membre_famille'));
        });

        // Sauvegarde membre de la famille
        $(document).on("submit", "#formulaire-famille", function (e) {
            e.preventDefault();
            
            // Validate password before submitting
            var passwordValidator = new PasswordValidation('password_familly', 'password_confirmation_familly', 'formulaire-famille');
            if (!passwordValidator.validatePasswordMatch()) {
                return false;
            }
            
            var membre_id = $("input[name='membre_id']").val();
            sauvegarde_membre_famille($(this), membre_id);
        });

        // Suppression membre de la famille
        $(document).on("click", ".btn-send-password", function (e) {
            var membre_id = $(this).attr("data-id");
            demande_reinitialisation_mot_de_passe(membre_id);
        });

        // Delete a family member through a scoped Bootstrap confirmation.
        $(document).on("click", ".btn-delete-famille", function (e) {
            e.preventDefault();
            var translations = window.memberTranslations || {};
            familyDeleteTarget = {
                id: $(this).attr("data-id"),
                name: $(this).attr("data-name") || ""
            };
            familyDeleteInProgress = false;
            restoreFamilyFormAfterDeleteDialog = $("#membreFamilleModal").hasClass("show");

            var message = translations.confirmDeleteFamily || "Êtes-vous sûr de vouloir supprimer :name de la famille ?";
            $("#deleteFamilyMemberModalMessage").text(message.replace(":name", familyDeleteTarget.name));

            if (restoreFamilyFormAfterDeleteDialog) {
                $("#membreFamilleModal").one("hidden.bs.modal", function () {
                    $("#deleteFamilyMemberModal").modal("show");
                }).modal("hide");
            } else {
                $("#deleteFamilyMemberModal").modal("show");
            }
        });

        $(document).on("hidden.bs.modal", "#deleteFamilyMemberModal", function () {
            if (restoreFamilyFormAfterDeleteDialog) {
                $("#membreFamilleModal").modal("show");
            }

            restoreFamilyFormAfterDeleteDialog = false;
            familyDeleteInProgress = false;
            familyDeleteTarget = null;
            $("#confirmDeleteFamilyMember").prop("disabled", false);
        });

        // Do not allow a pending DELETE to be dismissed and retried while its
        // request is still in flight. Cancel, Escape, and backdrop dismissal
        // remain available before confirmation and after an AJAX error.
        $(document).on("hide.bs.modal", "#deleteFamilyMemberModal", function (e) {
            if (familyDeleteInProgress) {
                e.preventDefault();
            }
        });

        $(document).on("click", "#confirmDeleteFamilyMember", function (e) {
            e.preventDefault();
            if (familyDeleteInProgress || !familyDeleteTarget) {
                return;
            }

            familyDeleteInProgress = true;
            $(this).prop("disabled", true);
            supprime_membre_famille(familyDeleteTarget.id);
        });

        // Toggle member status (enable/disable)
        $(document).on("click", ".btn-toggle-status", function (e) {
            var action = $(this).data('action');
            var member_id = $(this).data('member-id');
            
            // Set the action and member ID for the modal
            $("#statusAction").val(action);
            $("#statusMemberId").val(member_id);
            
            // Update modal content based on action using translations
            var translations = window.memberTranslations || {};
            var modalTitle = action === 'disable' 
                ? (translations.disableTitle || 'Désactiver le membre')
                : (translations.enableTitle || 'Activer le membre');
            var modalMessage = action === 'disable' 
                ? (translations.disableMessage || 'Êtes-vous sûr de vouloir désactiver ce membre?')
                : (translations.enableMessage || 'Êtes-vous sûr de vouloir activer ce membre?');
            
            $("#statusModal .modal-title").text(modalTitle);
            $("#statusModalMessage").text(modalMessage);
            $("#statusModal").modal('show');
        });

        // Delete member button  
        $(document).on("click", ".btn-delete3", function (e) {
            var member_id = $(this).data('member-id');
            
            // Reset modal state
            $("#deleteModalError").addClass("d-none");
            $("#deleteErrorMessage").text("");
            $("#deleteMemberNumberInput").val("").removeClass("is-invalid");
            $("#deleteMemberId").val(member_id);
            
            // Disable confirm button initially
            $("#confirmDelete").prop("disabled", true);
            
            $("#deleteModal").modal('show');
        });
        
        // Enable/disable delete confirm button based on input
        $(document).on("input", "#deleteMemberNumberInput", function() {
            var memberNumber = $("#deleteMemberNumberInput").val().trim();
            var actualMemberNumber = $("#actualDeleteMemberNumber").val().trim();
            
            // Enable button only if member number matches
            var isValid = memberNumber && memberNumber === actualMemberNumber;
            $("#confirmDelete").prop("disabled", !isValid);
        });

        // Archive member button
        $(document).on("click", ".btn-archive", function (e) {
            // Reset modal state
            $("#archiveModalError").addClass("d-none");
            $("#archiveErrorMessage").text("");
            $("#archiveMemberNumberInput").val("").removeClass("is-invalid");
            $("#reasonInput").val("").removeClass("is-invalid");
            
            // Disable confirm button initially
            $("#confirmArchive").prop("disabled", true);
            
            $("#archiveModal").modal('show');
        });
        
        // Enable/disable archive confirm button based on input
        $(document).on("input", "#archiveMemberNumberInput, #reasonInput", function() {
            var memberNumber = $("#archiveMemberNumberInput").val().trim();
            var reason = $("#reasonInput").val().trim();
            var actualMemberNumber = $("#actualArchiveMemberNumber").val().trim();
            
            // Update character count
            $("#reasonCharCount").text(reason.length);
            
            // Enable button only if both fields have values, member number matches, and reason is at least 60 chars
            var isValid = memberNumber && reason.length >= 60 && memberNumber === actualMemberNumber;
            $("#confirmArchive").prop("disabled", !isValid);
        });

        // Confirm archive button in modal
        $(document).on("click", "#confirmArchive", function (e) {
            var translations = window.memberTranslations || {};
            var memberNumber = $("#archiveMemberNumberInput").val().trim();
            var actualMemberNumber = $("#actualArchiveMemberNumber").val().trim();
            var reason = $("#reasonInput").val().trim();
            
            // Hide previous errors
            $("#archiveModalError").addClass("d-none");
            $("#archiveErrorMessage").text("");
            $("#archiveMemberNumberInput").removeClass("is-invalid");
            $("#reasonInput").removeClass("is-invalid");
            
            // Validate member number
            if (!memberNumber) {
                $("#archiveModalError").removeClass("d-none");
                $("#archiveErrorMessage").text(translations.memberNumberRequired || "Veuillez entrer le numéro du membre");
                $("#archiveMemberNumberInput").addClass("is-invalid");
                return;
            }
            
            // Check if member number matches
            if (memberNumber !== actualMemberNumber) {
                $("#archiveModalError").removeClass("d-none");
                $("#archiveErrorMessage").text(translations.memberNumberIncorrect || "Le numéro du membre est incorrect");
                $("#archiveMemberNumberInput").addClass("is-invalid");
                return;
            }
            
            // Validate reason
            if (!reason) {
                $("#archiveModalError").removeClass("d-none");
                $("#archiveErrorMessage").text(translations.archiveReasonRequired || "Veuillez entrer la raison de l'archivage");
                $("#reasonInput").addClass("is-invalid");
                return;
            }
            
            // Validate reason minimum length
            if (reason.length < 60) {
                $("#archiveModalError").removeClass("d-none");
                $("#archiveErrorMessage").text(translations.archiveReasonTooShort || "La raison doit contenir au moins 60 caractères");
                $("#reasonInput").addClass("is-invalid");
                return;
            }
            
            // If all validations pass, submit the form
            $("#archive_reason").val(reason);
            $("#archiveForm").submit();
        });

        // Confirm status toggle in modal
        $(document).on("click", "#confirmStatus", function (e) {
            var action = $("#statusAction").val();
            var memberId = $("#statusMemberId").val();
            
            // Submit the appropriate form based on action
            if (action === 'disable' || action === 'enable') {
                $("#toggleStatusForm").submit();
            }
        });

        // Confirm delete in modal
        $(document).on("click", "#confirmDelete", function (e) {
            var translations = window.memberTranslations || {};
            var memberNumber = $("#deleteMemberNumberInput").val().trim();
            var actualMemberNumber = $("#actualDeleteMemberNumber").val().trim();
            var modeInput = document.getElementById('deleteActionMode');
            
            // Hide previous errors
            $("#deleteModalError").addClass("d-none");
            $("#deleteErrorMessage").text("");
            $("#deleteMemberNumberInput").removeClass("is-invalid");
            
            // Validate member number
            if (!memberNumber) {
                $("#deleteModalError").removeClass("d-none");
                $("#deleteErrorMessage").text(translations.memberNumberRequired || "Veuillez entrer le numéro du membre");
                $("#deleteMemberNumberInput").addClass("is-invalid");
                return;
            }
            
            // Check if member number matches
            if (memberNumber !== actualMemberNumber) {
                $("#deleteModalError").removeClass("d-none");
                $("#deleteErrorMessage").text(translations.memberNumberIncorrect || "Le numéro du membre est incorrect");
                $("#deleteMemberNumberInput").addClass("is-invalid");
                return;
            }
            
            // Check if mode is 'request' (member deletion request) or 'delete' (manager deletion)
            if (modeInput && modeInput.value === 'request') {
                $("#deleteRequestForm").submit();
            } else {
                // If all validations pass, submit the deletion form
                $("#deleteForm").submit();
            }
        });
    }

    function init_table_membre_famille() {
        if ($('.datatable-membre').length > 0) {
            // Tableau des membres de la famille
            var id = $("input[name='id']").val();
            datatable_membre = $('.datatable-membre').DataTable({
                "bProcessing": true,
                "deferRender": true,
                "order": [[1, "asc"]],
                "pageLength": 25,
                "lengthMenu": [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                "responsive": true,
                "language": {
                    "url": window.lang_datatable
                },
                "ajax": {
                    url: route('membre_familles', id),
                    type: "POST",
                    data: {
                        "_token": $('meta[name=csrf-token]').attr("content")
                    }
                },
                "destroy": true
            });
        }
    }

    function demande_reinitialisation_mot_de_passe(membre_id) {
        $.ajax({
            url: route('reset_password_membre', membre_id),
            method: 'GET',
            data: {
                "_token": $('meta[name=csrf-token]').attr("content")
            },
            success: function (data) {
                notification(null, "success");
            }
        });
    }

    function ouvrir_modal_membre(call_url) {
        var membre_famille_id = $("input[name='id']").val();
        $.ajax({
            url: call_url,
            method: 'POST',
            data: {
                "_token": $('meta[name=csrf-token]').attr("content"),
                "membre_famille_id": membre_famille_id
            },
            success: function (data) {
                var modal = $("#membreFamilleFormulaire");
                modal.html(data);
                window.init_validator(modal);
                
                // Initialize password validation for modal
                setTimeout(function() {
                    new PasswordValidation('password_familly', 'password_confirmation_familly', 'formulaire-famille');
                }, 100);
                
                $('#membreFamilleModal').modal('toggle');
            }
        });
    }

    function supprime_membre_famille(membre_id) {
        $.ajax({
            url: route('destroy_membre_famille', membre_id),
            method: 'DELETE',
            dataType: 'json',
            data: {
                "_token": $('meta[name=csrf-token]').attr("content")
            },
            success: function (data) {
                restoreFamilyFormAfterDeleteDialog = false;
                familyDeleteInProgress = false;
                familyDeleteTarget = null;
                $('#deleteFamilyMemberModal').modal('hide');
                if (datatable_membre) { datatable_membre.ajax.reload(); }
            },
            error: function (xhr) {
                var msg = (xhr.responseJSON && xhr.responseJSON.message)
                    ? xhr.responseJSON.message
                    : ((window.memberTranslations || {}).deleteFamilyError || "Une erreur est survenue lors de la suppression.");
                notification(msg, "error");
                familyDeleteInProgress = false;
                $("#confirmDeleteFamilyMember").prop("disabled", false);
            }
        });
    }

    function sauvegarde_membre_famille(e, membre_id) {
        var route_url = route('membre.famille.store');
        if ($("input[name='membre_id']").val() !== "") {
            route_url = route('membre.famille.update', membre_id);
        }

        var $btn = e.find('.btn-update-famille');
        $btn.prop('disabled', true);

        $.ajax({
            url: route_url,
            method: 'POST',
            dataType: 'json',
            data: e.serialize(),
            success: function (data) {
                if (data.MEMBRE) {
                    $('#membreFamilleModal').modal('hide');
                    if (datatable_membre) { datatable_membre.ajax.reload(); }
                    notification(null, "success");
                } else if (data.ERROR) {
                    notification(data.ERROR, "error");
                    $btn.prop('disabled', false);
                }
            },
            error: function (xhr) {
                var msg = (xhr.responseJSON && xhr.responseJSON.message)
                    ? xhr.responseJSON.message
                    : "Une erreur est survenue lors de la sauvegarde.";
                notification(msg, "error");
                $btn.prop('disabled', false);
            }
        });
    }

    init();
});
